module.exports = __webpack_public_path__ + "static/media/profile-add.27b72603.svg";